<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
    <span>位置：</span>
    <ul class="placeul">
    <li><a href="#">首页</a></li>
    <li><a href="#">邮件</a></li>
    <li><a href="#">邮件发送帮助</a></li>
    </ul>
    </div>
    
    <div class="formbody">
    
    <div class="formtitle"><span>邮件发送设置</span></div>
    
    <ul class="forminfo">
    <li><label>发件人呢称</label><input name=""  v-model="nickname" type="text" class="dfinput" /></li>
    <li><label>发件人邮箱</label><input name="" v-model="email" type="text" class="dfinput" /><!--<i>请填写正确得邮箱号</i>-->
        
        <i v-if="status=='0'">未审核</i><i style="color:green;" v-else-if="status=='1'">审核通过</i><i style="color:red;" v-else>审核不通过</i>
    </li>
    <li><label>&nbsp;</label><input name="" type="button" @click="updemailconfig()" class="btn  maringht10" value="提交客服审核"/><input class="cancel" type="button" value="重置"></li>
    </ul>
    
      <div class="jian">&nbsp;</div>
     <div class="welinfo">
    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
    <b>注意事项 </b>
    </div>
    
    <ul class="infolist">
    <li><span>1.此处填的发件人昵称和邮箱，将会是您在该平台所发邮件的发件人呢称和邮件。</span></li> 
    <li><span>2.为快速确认邮件身份，您可通过欲指定邮箱向kefu@2office.cn 发送一个验证邮件（标题编注上：门牌号XXX，邮件验证 ）</span></li>
    <li><span>3.设置一般在一个工作日内生效，如果您主动联络上客服，生效时间可能只要几分钟</span></li>
    </ul>
    
    </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            nickname:'',
            email:'',
            status:0,
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/email/getuseremailconfig.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.nickname = res.data.nickname;
                    that.email = res.data.email;
                    that.status = res.data.status;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        updemailconfig(){
            var that = this;
            let data = {'nickname':this.nickname,'email':this.email};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/email/updemailconfig.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("修改成功");
                    that.getData();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/email/emailconfig.vue